const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* Splity marketplace verification guard — launch hotfix 2026-10-03 */
(() => {
  if (window.__splityMarketplaceVerificationGuard) return;
  window.__splityMarketplaceVerificationGuard = true;

  const API = 'https://splity-backend-48dv.onrender.com';
  const bypassClicks = new WeakSet();
  const bypassForms = new WeakSet();
  let cached = null;
  let cachedAt = 0;

  const readSession = () => {
    try { return JSON.parse(localStorage.getItem('splity-auth-session') || sessionStorage.getItem('splity-auth-session') || 'null'); }
    catch (_) { return null; }
  };
  const accountEmail = () => {
    const session = readSession();
    return String(
      session?.user?.email ||
      document.querySelector('[data-splity-dock][data-customer-email]')?.dataset.customerEmail ||
      document.querySelector('[data-customer-email]')?.dataset.customerEmail ||
      ''
    ).trim().toLowerCase();
  };

  const addStyles = () => {
    if (document.getElementById('splity-marketplace-verification-hotfix')) return;
    const style = document.createElement('style');
    style.id = 'splity-marketplace-verification-hotfix';
    style.textContent = `
      .splity-verify-gate[hidden]{display:none!important}.splity-verify-gate{position:fixed;inset:0;z-index:2147483640;display:grid;place-items:center;padding:18px;font-family:Inter,Manrope,system-ui,sans-serif}.splity-verify-gate__backdrop{position:absolute;inset:0;border:0;background:rgba(4,3,8,.78);backdrop-filter:blur(9px)}.splity-verify-gate__card{position:relative;width:min(440px,100%);padding:27px 24px;border:1px solid rgba(139,92,246,.42);border-radius:24px;background:linear-gradient(150deg,#17111f,#0b090f);color:#fff;box-shadow:0 30px 90px rgba(0,0,0,.5);text-align:center}.splity-verify-gate__icon{display:grid;place-items:center;width:60px;height:60px;margin:0 auto 15px;border-radius:18px;background:linear-gradient(135deg,#7c3aed,#4f46e5);font-size:27px;font-weight:900}.splity-verify-gate h2{margin:0 0 9px;color:#fff;font-size:22px;line-height:1.2}.splity-verify-gate p{margin:0;color:#d2cadb;font-size:14px;line-height:1.55}.splity-verify-gate__actions{display:grid;gap:10px;margin-top:21px}.splity-verify-gate__actions a,.splity-verify-gate__actions button{display:grid;place-items:center;min-height:48px;padding:0 16px;border-radius:14px;font:800 14px/1 system-ui,sans-serif;text-decoration:none;cursor:pointer}.splity-verify-gate__actions a{border:0;background:linear-gradient(90deg,#7c3aed,#5b45f5);color:#fff}.splity-verify-gate__actions button{border:1px solid #41364d;background:#17121d;color:#e8e1ed}html[data-splity-theme="light"] .splity-verify-gate__card{background:#fff;color:#17131f;border-color:#d9c8f0}html[data-splity-theme="light"] .splity-verify-gate h2{color:#17131f}html[data-splity-theme="light"] .splity-verify-gate p{color:#5d5566}html[data-splity-theme="light"] .splity-verify-gate__actions button{background:#f7f3fb;color:#33293d;border-color:#ded4e7}`;
    document.head.appendChild(style);
  };

  const modal = () => {
    addStyles();
    let node = document.querySelector('[data-splity-verify-gate]');
    if (node) return node;
    node = document.createElement('div');
    node.className = 'splity-verify-gate';
    node.dataset.splityVerifyGate = '';
    node.hidden = true;
    node.innerHTML = `<button type="button" class="splity-verify-gate__backdrop" data-verify-close aria-label="Cerrar"></button><section class="splity-verify-gate__card" role="dialog" aria-modal="true" aria-labelledby="splityVerifyTitle"><div class="splity-verify-gate__icon">✓</div><h2 id="splityVerifyTitle">Verificación requerida</h2><p data-verify-copy></p><div class="splity-verify-gate__actions"><a href="/pages/mi-perfil">Verificar mi cuenta</a><button type="button" data-verify-close>Ahora no</button></div></section>`;
    document.body.appendChild(node);
    node.querySelectorAll('[data-verify-close]').forEach((button) => button.addEventListener('click', () => {
      node.hidden = true;
      document.documentElement.style.overflow = '';
    }));
    return node;
  };

  const showGate = (message) => {
    const node = modal();
    node.querySelector('[data-verify-copy]').textContent = message;
    node.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  };

  const verificationMessage = (emailVerified, phoneVerified) => {
    if (!emailVerified && !phoneVerified) return 'Para comprar o publicar en Splity debes verificar tu correo y tu WhatsApp.';
    if (!emailVerified) return 'Para continuar debes verificar tu correo electrónico.';
    if (!phoneVerified) return 'Para continuar debes verificar tu WhatsApp.';
    return '';
  };

  const fetchStatus = async (path, email) => {
    const response = await fetch(`${API}${path}?email=${encodeURIComponent(email)}`, { headers:{Accept:'application/json'}, cache:'no-store' });
    const data = await response.json().catch(() => ({}));
    if (!response.ok || data.ok === false) throw new Error(data.error || 'No se pudo comprobar la verificación');
    return data;
  };

  const getVerification = async (force = false) => {
    const email = accountEmail();
    if (!email) return { emailVerified:false, phoneVerified:false, noSession:true };
    if (!force && cached && Date.now() - cachedAt < 15000) return cached;
    const [emailState, phoneState] = await Promise.all([
      fetchStatus('/api/profiles/email/status', email),
      fetchStatus('/api/profiles/whatsapp/status', email)
    ]);
    cached = {
      emailVerified: emailState.verified === true || emailState.emailVerified === true,
      phoneVerified: phoneState.verified === true || phoneState.phoneVerified === true
    };
    cachedAt = Date.now();
    return cached;
  };

  const requireVerification = async () => {
    try {
      const state = await getVerification(true);
      if (state.emailVerified && state.phoneVerified) return true;
      showGate(state.noSession ? 'Inicia sesión y verifica tu correo y tu WhatsApp antes de comprar o publicar.' : verificationMessage(state.emailVerified, state.phoneVerified));
      return false;
    } catch (_) {
      showGate('No pudimos comprobar tus verificaciones en este momento. Revisa en Mi perfil que tu correo y WhatsApp estén verificados e inténtalo nuevamente.');
      return false;
    }
  };

  const textOf = (node) => String(node?.textContent || '').replace(/\s+/g,' ').trim().toLowerCase();
  const isMarketplaceClick = (node) => {
    if (!node) return false;
    if (node.matches?.('[data-join-index],[data-confirm],[data-confirm-buy],[data-join-group],[data-buy-group]')) return true;
    return /^(unirme al grupo|unirme|confirmar compra|comprar|continuar al pago)$/.test(textOf(node));
  };
  const isPublishForm = (form, submitter) => {
    if (!(form instanceof HTMLFormElement)) return false;
    if (form.matches('[data-flow-form]')) return true;
    return /enviar a revisi[oó]n|publicar suscripci[oó]n|publicar/.test(textOf(submitter));
  };

  document.addEventListener('click', async (event) => {
    const target = event.target?.closest?.('button,a');
    if (!target || !isMarketplaceClick(target)) return;
    if (bypassClicks.has(target)) { bypassClicks.delete(target); return; }
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!(await requireVerification())) return;
    bypassClicks.add(target);
    target.click();
  }, true);

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    const submitter = event.submitter instanceof HTMLElement ? event.submitter : null;
    if (!isPublishForm(form, submitter)) return;
    if (bypassForms.has(form)) { bypassForms.delete(form); return; }
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!(await requireVerification())) return;
    bypassForms.add(form);
    if (typeof form.requestSubmit === 'function') form.requestSubmit(submitter || undefined);
  }, true);
})();
